/**
 * ScrollToTop — composant utilitaire React Router qui force le scroll en haut
 * de la page à chaque changement de route.
 *
 * Par défaut React Router préserve la position de scroll lors d'une navigation,
 * ce qui donne un comportement bizarre : cliquer sur "Comparer mon offre"
 * depuis le bas de la home → on arrive sur /comparateur déjà scrollé en bas.
 *
 * Usage : à mettre une seule fois dans App.js, à l'intérieur de <BrowserRouter>.
 *
 * Comportement :
 *   - Scroll en haut sur changement de pathname uniquement (pas sur change de
 *     query params — utile pour les filtres qui ne doivent pas tout reset).
 *   - Si un hash est présent (ex: /page#section), on tente le scroll vers
 *     l'ancre au lieu de remonter en haut.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // Si l'URL contient un hash (ex: #faq), scroll vers l'ancre.
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                el.scrollIntoView({ behavior: "instant", block: "start" });
                return;
            }
        }
        // Sinon, remonte en haut. "instant" = pas d'animation pour ne pas
        // créer de saccade visible juste après l'apparition du nouveau contenu.
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [pathname, hash]);

    return null;
}
